import React from 'react';

function ArrowLeftThin() {
  return (
    <svg
      width="20px"
      height="15px"
      viewBox="0 0 20 15"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Web-landing-Page"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="iPhone-XS-Copy-2"
          transform="translate(-18.000000, -62.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="right-arrow-(2)" transform="translate(18.000000, 62.000000)">
            <path
              d="M13.253125,0.629375 C12.985,0.351875 12.53875,0.351875 12.26125,0.629375 C11.993125,0.8975 11.993125,1.34375 12.26125,1.61125 L17.290625,6.640625 L0.694375,6.640625 C0.3075,6.64125 0,6.94875 0,7.335625 C0,7.7225 0.3075,8.04 0.694375,8.04 L17.290625,8.04 L12.26125,13.06 C11.993125,13.3375 11.993125,13.784375 12.26125,14.051875 C12.53875,14.329375 12.985625,14.329375 13.253125,14.051875 L19.473125,7.831875 C19.750625,7.56375 19.750625,7.1175 19.473125,6.85 L13.253125,0.629375 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ArrowLeftThin;
